import React, { useState, useEffect, useRef } from 'react';
import { useField } from '@unform/core';
import PropTypes from 'prop-types';

import Autocomplete from '@material-ui/lab/Autocomplete';
import { withStyles } from '@material-ui/core/styles';
import InputLabel from '~/components/InputLabel';
import StyledTextField from '~/styles/components/StyledTextField';

import { Container } from './styles';

const StyledAutocomplete = withStyles({
  clearIndicator: {
    color: '#C2C2C2',
  },
  popupIndicator: {
    color: '#C2C2C2',
  },
})(Autocomplete);

function AutocompleteMultipleComponent({ name, label, data }) {
  const [value, setValue] = useState([]);

  const inputRef = useRef(null);
  const { fieldName, defaultValue, registerField, error, clearError } =
    useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
      getValue: (ref) => {
        return value.join(', ');
      },
      clearValue: (ref) => {
        ref.value = '';
        setValue([]);
      },
    });
  }, [fieldName, registerField, value]);

  return (
    <Container>
      <InputLabel>{label}</InputLabel>

      <StyledAutocomplete
        onFocus={clearError}
        onChange={(event, text) => setValue(text)}
        multiple
        options={data}
        value={value}
        getOptionLabel={(option) => option}
        size="small"
        fullWidth
        noOptionsText="Sem opções"
        renderInput={(params) => (
          <StyledTextField
            id={fieldName}
            inputRef={inputRef}
            defaultValue={defaultValue}
            variant="outlined"
            error={error !== undefined}
            helperText={error}
            {...params}
          />
        )}
      />
    </Container>
  );
}

AutocompleteMultipleComponent.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default AutocompleteMultipleComponent;
